export const LOAD_CUSTOMERS = 'load_customers';
export const CUSTOMERS_LOADED = 'set_loaded_customers';
export const RESET_CUSTOMERS = 'reset_customers';
export const SYNC_FAILED = 'customers_sync_error';
